<bp-hl-area-container [name]="titel" [scrollX]="true">
	@if (!istKaPunkt) {
		<div class="alert alert-warning" data-testid="ka-maske-falsches-verfahren">
			Dieser Punkt ist keine Aufnahme nach der Bodenkundlichen Kartieranleitung. Die Maske wird
			deshalb nicht angezeigt; das Kartierverfahren steht beim Anlegen des Projekts fest.
		</div>
	} @else {
		<table class="table table-sm table-striped ka-horizont-tabelle" data-testid="ka-horizont-tabelle">
			<thead>
				<tr>
					<th class="ka-zeilennr"></th>
					<th class="ka-spalte-schmal"></th>
					<th class="ka-spalte-schmal">{{ grenzeTitel('obergrenze') }}</th>
					<th class="ka-spalte-schmal">{{ grenzeTitel('untergrenze') }}</th>
					@for (feld of spalten; track feld.id) {
						<th [class]="feld.id === 'horizontBemerkungen' ? 'ka-spalte-breit' : 'ka-spalte'"
							[title]="hinweis(feld)"
							[attr.data-testid]="'ka-spalte-' + feld.id">{{ beschriftung(feld) }}</th>
					}
					<th class="ka-spalte-schmal"></th>
				</tr>
			</thead>
			<tbody>
				@for (h of horizonte; track h.id; let i = $index) {
					<tr [attr.data-testid]="'ka-horizont-zeile-' + i">
						<td class="ka-zeilennr">{{ i + 1 }}</td>
						<td>
							<button type="button" class="btn btn-outline-secondary btn-sm"
								title="Neuen Horizont vor dieser Zeile einfügen"
								(click)="onZeileDazu(i)"><i class="bi bi-plus"></i><i class="bi bi-arrow-90deg-right"></i></button>
						</td>
						<td class="ka-spalte-schmal">
							<wd-number-input [name]="grenzeName('obergrenze', i)" [model]="grenze('obergrenze', i)"
								(modelChange)="setzeGrenze('obergrenze', i, $event)" [hideComments]="true"></wd-number-input>
						</td>
						<td class="ka-spalte-schmal">
							<wd-number-input [name]="grenzeName('untergrenze', i)" [model]="grenze('untergrenze', i)"
								(modelChange)="setzeGrenze('untergrenze', i, $event)" [hideComments]="true"></wd-number-input>
						</td>
						@for (feld of spalten; track feld.id) {
							<td [class]="feld.id === 'horizontBemerkungen' ? 'ka-spalte-breit' : 'ka-spalte'">
								@if (feld.art === 'zahl') {
									<wd-number-input [name]="name(feld, i)" [model]="zahl(feld, i)"
										(modelChange)="setze(feld, $event, i)" [nonEmpty]="pflicht(feld)" [hideComments]="true"></wd-number-input>
								} @else {
									<wd-text-input [name]="name(feld, i)" [model]="text(feld, i)"
										(modelChange)="setze(feld, $event, i)" [nonEmpty]="pflicht(feld)" [hideComments]="true"></wd-text-input>
								}
							</td>
						}
						<td class="ka-spalte-schmal">
							<button type="button" class="btn btn-outline-danger btn-sm"
								title="Diesen Horizont löschen" (click)="onZeileLoeschen(i)"><i class="bi bi-trash"></i></button>
						</td>
					</tr>
				} @empty {
					<tr>
						<td [attr.colspan]="spalten.length + 5" class="ka-leer-hinweis" data-testid="ka-horizonte-leer">
							Noch keine Horizonte. Mit „Horizont anfügen" die erste Zeile anlegen.
						</td>
					</tr>
				}
			</tbody>
		</table>

		<button type="button" class="btn btn-outline-primary btn-sm" data-testid="ka-horizont-anfuegen"
			(click)="onZeileDazu()"><i class="bi bi-plus"></i><span class="ms-1">Horizont anfügen</span></button>

		<div class="ka-fusszeile" data-testid="ka-maske-fuss">{{ fussText }}</div>
	}
</bp-hl-area-container>
